import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { canAccessClientsModule, isAdminOrAbove } from '../../utils/permissions';
import Organizations from '../Organizations/Organizations';
import Outlets from '../Outlets/Outlets';
import Clients from '../Clients/Clients';
import '../AuditorRoster/AuditorRoster.css';
import '../../components/BulkImportPanel.css';
import './ClientsHub.css';

/**
 * Clients & Stores: client organizations, their stores and their portal
 * logins on one page, one tab each. Clients and Stores are Admin only;
 * Client logins follows the existing client-user permission.
 */
function ClientsHub() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const [prefillOrgId, setPrefillOrgId] = useState('');

  const tabs = [
    { key: 'clients', label: 'Clients', show: isAdminOrAbove(user) },
    { key: 'stores', label: 'Stores', show: isAdminOrAbove(user) },
    { key: 'logins', label: 'Client logins', show: canAccessClientsModule(user) },
  ].filter((item) => item.show);

  const requested = params.get('tab');
  const tab = tabs.some((item) => item.key === requested) ? requested : tabs[0]?.key;
  const orgFilter = params.get('client') || 'all';

  const go = (key, extra = {}) => setParams({ tab: key, ...extra }, { replace: true });

  return (
    <div className="page clients-hub">
      <header className="page__header">
        <div>
          <p className="page__eyebrow">Operations</p>
          <h1>Clients &amp; Stores</h1>
          <p className="roster-page__subtitle">
            Client organizations, their stores and who can see the client portal, all in one place.
          </p>
        </div>
      </header>

      <div className="roster-tabs" role="tablist" aria-label="Clients and stores">
        {tabs.map((item) => (
          <button
            key={item.key}
            type="button"
            role="tab"
            id={`hub-tab-${item.key}`}
            aria-selected={tab === item.key}
            aria-controls={`hub-panel-${item.key}`}
            className={`roster-tabs__tab ${tab === item.key ? 'roster-tabs__tab--active' : ''}`}
            onClick={() => go(item.key)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <section className="clients-hub__panel" role="tabpanel" id={`hub-panel-${tab}`} aria-labelledby={`hub-tab-${tab}`}>
        {tab === 'clients' ? (
          <Organizations
            embedded
            onViewStores={(org) => go('stores', { client: String(org.id) })}
            onManageLogins={(org) => {
              if (canAccessClientsModule(user)) {
                setPrefillOrgId(String(org.id));
                go('logins');
              }
            }}
          />
        ) : tab === 'stores' ? (
          <Outlets embedded initialOrgId={orgFilter} />
        ) : tab === 'logins' ? (
          <Clients embedded prefillOrgId={prefillOrgId} onPrefillUsed={() => setPrefillOrgId('')} />
        ) : null}
      </section>
    </div>
  );
}

export default ClientsHub;
